import React, { useState, useMemo } from 'react';
import algoliasearch from 'algoliasearch/lite';
import PropTypes from 'prop-types';

import { InstantSearch, InstantSearchSSRProvider, Configure, Index } from 'react-instantsearch';
import Hits from './Hits';
import ResultHeader from './ResultHeader';
import ResultNavBar from './ResultNavBar';
import Router from './Router';
import './ResultContainer.scss';

function ResultContainer(props) {
  const { searchState: initialSearchState, serverState } = props;
  const [searchState, setSearchState] = useState(initialSearchState);
  const onSearchStateChange = (state) => {
    setSearchState(state);
  };

  const changeTab = (section) => {
    Router.updateQuery({ section });
  };
  const searchString = props?.searchState.query;
  const section = props?.location.query.section || props?.section;

  const {
    texts,
    indexNames,
    marketunit,
    algoliaApplicationID,
    algoliaApiKey,
    hitsPerPage,
    imageDomain,
  } = props;

  const searchClient = useMemo(
    () => algoliasearch(algoliaApplicationID, algoliaApiKey),
    [algoliaApplicationID, algoliaApiKey],
  );

  const menuTabs = [
    {
      section: 'destination',
      value: texts.resorts,
      index: indexNames.destination.replace('MUCD', marketunit?.toUpperCase()),
      skipIndex: true,
    },
    {
      section: 'hotel',
      value: texts.hotels,
      index: indexNames.hotel.replace('MUCD', marketunit?.toUpperCase()),
    },
    indexNames.faq && {
      section: 'faq',
      value: texts.faq,
      index: indexNames.faq.replace('MUCD', marketunit?.toUpperCase()),
    },
    {
      section: 'page',
      value: texts.campaigns,
      index: indexNames.page.replace('MUCD', marketunit?.toUpperCase()),
    },
  ].filter((mt) => mt);
  const initialResults = serverState?.initialResults || {};

  const scopedResults = Object.entries(initialResults).map(([indexId, results]) => ({
    indexId,
    results: results.results
      ? results.results[0]
      : {
          nbHits: 0,
        },
  }));

  let totalNrOfHits = 0;
  menuTabs.forEach((tab) => {
    const index = initialResults[tab.index];
    if (index) {
      totalNrOfHits += index.results[0].nbHits;
    }
  });

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <InstantSearchSSRProvider {...serverState}>
      <InstantSearch
        searchClient={searchClient}
        indexName={menuTabs[0].index}
        searchState={searchState}
        onSearchStateChange={onSearchStateChange}
      >
        <Configure hitsPerPage={hitsPerPage} query={searchString} />

        <ResultHeader
          header={texts.resultHeader}
          searchString={searchString}
          nrOfHits={totalNrOfHits}
        />
        <ResultNavBar
          selectedTab={section}
          changeTab={changeTab}
          labels={menuTabs}
          scopedResults={scopedResults}
        />
        {menuTabs.map((tab) => {
          let hitComponent =
            tab.section === section || (tab.section === 'destination' && !section) ? (
              <Hits texts={texts} imageDomain={imageDomain} />
            ) : null;
          if (!tab.skipIndex) {
            hitComponent = <Index indexName={tab.index}>{hitComponent}</Index>;
          }
          return (
            <div key={tab.section}>
              <Index indexName={tab.index}>{hitComponent}</Index>
            </div>
          );
        })}
      </InstantSearch>
    </InstantSearchSSRProvider>
  );
}

ResultContainer.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
};

export { ResultContainer };
